import withBulkAction from './with-bulk-action/with-bulk-action'
import BulkActionProvider from './provider/provider'
import SelectAllButton from './select-all/select-all.container'
import ActionButton from './action-button/action-button'
import BulkCheckbox from './bulk-checkbox/bulk-checkbox'
import { useContext } from 'react'
import BulkActionContext from './context'

const useBulkAction = () => {
  return useContext(BulkActionContext)
}

export {
  withBulkAction,
  BulkActionProvider,
  BulkCheckbox,
  SelectAllButton,
  ActionButton,
  useBulkAction
}
